// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6ac5c05b","239":"a821b557","732":"e7b1e103"}[chunkId] + ".chunk.js";
};